import { Box, SvgIconTypeMap, SxProps } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";

import { theme } from "../mui-customs/Theme";
import Typography from "./Typography";

interface NoDataUIProps {
  Icon?: OverridableComponent<SvgIconTypeMap<{}, "svg">> & {
    muiName: string;
  };
  iconSize?: number;
  displayMessage: string;
  sx?: SxProps;
}

const NoDataUI = ({
  Icon,
  iconSize = 50,
  displayMessage,
  sx,
}: NoDataUIProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        minHeight: "400px",
        flexDirection: "column",
        gap: 2,
        boxSizing: "border-box",
        ...sx,
      }}
    >
      {Icon && <Icon sx={{ color: theme.whiteBg.WBG4, fontSize: iconSize }} />}
      <Typography variant="title4" sx={{ color: theme.whiteBg.WBG4 }}>
        {displayMessage}
      </Typography>
    </Box>
  );
};

export default NoDataUI;
